import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlansManagerStore } from './plans-manager.store';

const PlansManagerContext = React.createContext<PlansManagerStore | null>(null);

export const PlansManagerProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<PlansManagerStore>(() => new PlansManagerStore(navigate));

   return <PlansManagerContext.Provider value={store}>{children}</PlansManagerContext.Provider>;
};

export const usePlansManager = () => {
   const ctx = React.useContext(PlansManagerContext);
   if (!ctx) {
      throw new Error('usePlansManager must be used inside PlansManagerContext');
   }
   return ctx;
};
